import { useEffect } from 'react'
import { useParams } from 'react-router'
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import {
  AllCheckStatus,
  JoinTermsValue,
  RecoilStateList,
  termsModalOpen,
  uiData
} from 'src/recoil/common'
import {
  Rop01AllTermsContainer,
  Rop01EachTermsContainer,
  Rop01EachTermsItems,
  Rop01TermsAgreeContents,
  Rop01TermsAgreeWrap,
  TermsModalAgreeBtn,
  TermsModalBox,
  TermsModalBtnContainer,
  TermsModalCancelBtn,
  TermsModalContentsBox,
  TermsModalWrapper,
} from 'src/styles/styledcomponent/views/Rop01/Terms'

import {
  CheckIcon,
} from 'src/styles/styledcomponent/views/RopForm/Terms'
import { monitoredOpen } from 'src/service/utils/sentry/navigation'
import { JoinTermsDetail, PramsKeys } from 'src/types/type'

const Terms = (props: any): JSX.Element => {
  const { requestID } = useParams<PramsKeys>()

  const { TelType, termsAgree, AllTermsAgree, TermsData, isAgreeAllRequiredTerms } = useRecoilValue(RecoilStateList)
  const [
    {
      layoutsTerms: { actColor, borderRadius },
    },
  ] = useRecoilState(uiData)
  const [termsModal, setTermsModal] = useRecoilState(termsModalOpen)

  const setAllTermsAgree = useSetRecoilState(AllCheckStatus)
  const setTermsAgree = useSetRecoilState(JoinTermsValue)

  const resetTerms = useResetRecoilState(AllCheckStatus)

  const agreeAllTerms = () => {
    const arrCopy = [...termsAgree]
    if (!AllTermsAgree) {
      TermsData?.Terms?.forEach((terms: JoinTermsDetail) => {
        if (terms.Order !== undefined && terms.Required === 1) {
          arrCopy[terms.Order - 1] = 1
        }
      })
    } else {
      arrCopy.fill(0)
    }
    setTermsAgree(arrCopy)
    setAllTermsAgree((AllTermsAgree) => !AllTermsAgree)
    setTermsModal(false)
  }

  const agreeEachTerms = (order: number) => {
    // 개별동의
    const arrCopy = [...termsAgree]
    arrCopy[order - 1] = termsAgree[order - 1] === 1 ? 0 : 1
    setTermsAgree(arrCopy)
  }
  const termsOpen = (order: number): void => {
    // 약관 보기
    const width: number = 400
    const height: number = 600
    const url: string | undefined = requestID
      ? `/terms/${requestID}/${TelType}/${TermsData.TermsIdx}/${order}`
      : undefined

    if (url) {
      monitoredOpen(url, 'terms', '_blank', {
        windowFeatures: `width=${width}, height=${height}`,
      })
    }
  }

  useEffect(() => {
    resetTerms()
    setAllTermsAgree(false)
    setTermsModal(false)
  }, [
    resetTerms,
    TelType,
    TermsData,
    setAllTermsAgree,
    setTermsModal,
  ])

  useEffect(() => {
    setAllTermsAgree(isAgreeAllRequiredTerms)
  }, [isAgreeAllRequiredTerms, setAllTermsAgree])

  return (
    <>
      <Rop01TermsAgreeWrap borderRadius={borderRadius}>
        <Rop01TermsAgreeContents>
          <Rop01AllTermsContainer
            checkColor={actColor}
            active={AllTermsAgree}
            onClick={agreeAllTerms}
          >
            <span>
              <CheckIcon checkColor={actColor} primary />
            </span>
            <p>서비스 필수 항목 모두 동의</p>
          </Rop01AllTermsContainer>
          <Rop01EachTermsContainer>
            {TermsData?.Terms?.map((terms: JoinTermsDetail, index: number) => (
              <Rop01EachTermsItems
                key={index}
                onClick={() => terms.Order !== undefined && agreeEachTerms(terms.Order)}
              >
                <CheckIcon
                  checkColor={actColor}
                  active={terms.Order !== undefined && termsAgree[terms.Order - 1] === 1}
                />
                <p onClick={() => terms.Order !== undefined && termsOpen(terms.Order)}>
                  {terms.Title}
                  {terms.Required === 1 ? '' : '(선택)'}
                </p>
              </Rop01EachTermsItems>
            ))}
          </Rop01EachTermsContainer>
        </Rop01TermsAgreeContents>
      </Rop01TermsAgreeWrap>

      {termsModal && (
        <TermsModalWrapper>
          <TermsModalBox>
            <TermsModalContentsBox>
              <p>
                서비스 이용을 위하여 약관동의가 필요합니다. 모두(선택약관 미동의) 동의하시겠습니까?
              </p>
            </TermsModalContentsBox>
            <TermsModalBtnContainer>
              <TermsModalCancelBtn onClick={() => setTermsModal(false)}>취소</TermsModalCancelBtn>
              <TermsModalAgreeBtn onClick={agreeAllTerms}>확인</TermsModalAgreeBtn>
            </TermsModalBtnContainer>
          </TermsModalBox>
        </TermsModalWrapper>
      )}
    </>
  )
}
export default Terms
